import { select } from 'd3-selection';
import * as d3 from 'd3';
import * as funTooltip from './tooltip';
import store from '../../store';

const { getState } = store;
const app = document.querySelector('.mapa');

function validate(event) {
  // Se não tem evento, é possível que tenha sido Trigger
  if (!event.pageX || !event.pageY) {
    const active = document.querySelector('.path__municipio.active');
    const parent = document.querySelector('.mapa__container');
    const tooltipH = document.querySelector('.mapa__tooltip').clientHeight;
    const { offsetLeft } = app;
    // POSIÇÃO DO PATH EM RELAÇÃO AO VIEWPORT
    const { x, y, width } = active.getBoundingClientRect();
    // POSIÇÃO DO PARENT PATH EM RELAÇÃO AO VIEWPORT
    const { y: parentY } = parent.getBoundingClientRect();
    const offsetX = x - (offsetLeft - (width));
    const offsetY = y - (parentY - (tooltipH / 2) - 20);
    return {
      offsetX,
      offsetY,
    };
  }
  return event;
}

export function handleMouseOver({ dadosMunicipio }) {
  const { initial } = getState();
  const { param } = initial;
  const { currentKey } = param;
  const active = document.querySelector('.path__municipio.active');
  if (active) {
    active.classList.remove('active');
  }
  select('.mapa__tooltip')
    .style('pointer-events', 'none')
    .style('opacity', '1')
    .html(funTooltip[currentKey.tooltip](dadosMunicipio, currentKey));
  select(this.parentNode.appendChild(this))
    .classed('active', true);
}

export function handleMouseMove() {
  const { clientWidth } = document.querySelector('.mapa__tooltip');
  const { offsetY, offsetX } = validate(d3.event);
  // console.log('pageX', pageX);
  // console.log('pageY', pageY);
  // const { offsetLeft, offsetTop } = app;
  // console.log('offsetLeft', offsetLeft);
  // console.log('offsetTop', offsetTop);
  // console.log('@@@ pageY - offsetTop', pageY - offsetTop);
  let xRect;
  let yRect;
  const sizeScreen = window.screen.availWidth - clientWidth;
  // const sizeMouse = clientWidth + pageX;
  const sizeMouse = clientWidth + offsetX;

  if (sizeMouse < sizeScreen) {
    // xRect = pageX - offsetLeft;
    xRect = offsetX;
    // yRect = pageY - offsetTop; // TUDO ISSO É IGUAL AO d3.offsetY
    yRect = offsetY;
  } else {
    // xRect = pageX - (offsetLeft + clientWidth);
    xRect = offsetX - clientWidth;
    // yRect = pageY - offsetTop;
    yRect = offsetY;
  }
  select('.mapa__tooltip')
    .style('transform', `translate(${(xRect) + 20}px, ${(yRect) + 20}px)`);
}

export function handleMouseOut() {
  select('.mapa__tooltip')
    .style('pointer-events', 'none')
    .style('opacity', '0');

  select(this)
    .classed('active', false);
}




// WEBPACK FOOTER //
// ./src/components/mapa/mouse.js